import { NgModule } from '@angular/core';

// Angular Material Components
import {MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import {MatInputModule as MatInputModule } from '@angular/material/input';
import {MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import {MatSelectModule as MatSelectModule } from '@angular/material/select';
import {MatSliderModule as MatSliderModule } from '@angular/material/slider';

import {MatListModule as MatListModule } from '@angular/material/list';

import {MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import {MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import {MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatCardModule as MatCardModule } from '@angular/material/card';
import {MatChipsModule as MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import {MatMenuModule as MatMenuModule } from '@angular/material/menu';
import {MatPaginatorModule as MatPaginatorModule } from '@angular/material/paginator';
import {MatProgressBarModule as MatProgressBarModule } from '@angular/material/progress-bar';
import {MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import {MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';


@NgModule({
  exports: [
    MatCheckboxModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatRadioModule,
     MatTreeModule,
    MatRippleModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatNativeDateModule,
    MatButtonModule,
    MatProgressBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule
  ]
})
export class MaterialModule { }
